import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-password-feedback',
  templateUrl: './password-feedback.component.html',
  styleUrls: ['./password-feedback.component.scss'],
  imports: [],
})
export class PasswordFeedbackComponent {
  @Input()
  feedback = { warning: null, suggestions: null };
}
